import router from "@/@admin/router";
import { $api, Question, RouterUtilClass } from "@/shared";
import { ApiResourceResult } from "@/shared/vuex";
import { StoreOptions } from "vuex";

export interface QuestionsVuexState extends ApiResourceResult<Question> {
  questions?: Question[];
  loading: boolean;
}

export const QuestionsVuex: StoreOptions<QuestionsVuexState> = {
  ...{ namespaced: true },
  state: {
    questions: undefined,
    loading: false,
  },
  mutations: {},
  actions: {
    /**
     * Fetches questions
     * @param context
     */
    fetch(context) {
      context.state.loading = true;
      $api.admin
        .get<ApiResourceResult<Question>>(
          `/v1/questions?${RouterUtilClass.extractQuery(router)}`
        )
        .then((resp) => {
          context.state.count = resp.data.count;
          context.state.next = resp.data.next;
          context.state.skipped = resp.data.skipped;
          context.state.questions = resp.data.resources;
          //   Vue.set
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
  },
  modules: {},
  //
  getters: {},
};
